import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import MaterialSubcategoryForm from "components/form/MaterialSubcategoryForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Sottocategoria creata con successo",
        errorMsg: "Errore nella creazione della sottocategoria",
        navigateTo: { link: "/gestione-materiali/sotto-categorie" },
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function NuovaSottoCatMateriale() {
    return (
        <GridColumn>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Nuova Sottocategoria Materiale</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <MaterialSubcategoryForm />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default NuovaSottoCatMateriale;
